/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it check colour blindness?`)
};

const es_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Comprueba el daltonismo?`)
};

const de_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüft es auf Farbenblindheit?`)
};

const nl_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleert het op kleurenblindheid?`)
};

const fr_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie-t-il le daltonisme ?`)
};

const it_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla il daltonismo?`)
};

const pt_br2_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela verifica daltonismo?`)
};

const pt_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica o daltonismo?`)
};

const ja_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色覚異常のチェックはできますか?`)
};

const zh_cc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能检测色盲情况吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_q4", locale)
	if (locale === "en") return en_cc_faq_q4(inputs)
	if (locale === "es") return es_cc_faq_q4(inputs)
	if (locale === "de") return de_cc_faq_q4(inputs)
	if (locale === "nl") return nl_cc_faq_q4(inputs)
	if (locale === "fr") return fr_cc_faq_q4(inputs)
	if (locale === "it") return it_cc_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_q4(inputs)
	if (locale === "pt") return pt_cc_faq_q4(inputs)
	if (locale === "ja") return ja_cc_faq_q4(inputs)
	return zh_cc_faq_q4(inputs)
};